import { render, staticRenderFns } from "./BoltonCity.vue?vue&type=template&id=5c9d0218&scoped=true&"
import script from "./BoltonCity.vue?vue&type=script&lang=js&"
export * from "./BoltonCity.vue?vue&type=script&lang=js&"
import style0 from "./BoltonCity.vue?vue&type=style&index=0&id=5c9d0218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d0218",
  null
  
)

export default component.exports